import React, { useCallback, useRef } from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  width: 100%;
  overflow-x: auto;
  > div {
    height: 5px;
  }
`;

const useHookWithRefCallback = () => {
  const ref = useRef(null);
  const setRef = useCallback((node) => {
    if (node && node.childNodes.length === 2) {
      const $top = node.childNodes[0];
      const $bottom = node.childNodes[1];

      $top.childNodes[0].style.width = `${$bottom.childNodes[0].offsetWidth}px`;
      $bottom.style.overflowX = 'auto';

      $top.onscroll = function () {
        $bottom.scrollLeft = $top.scrollLeft;
      };
      $bottom.onscroll = function () {
        $top.scrollLeft = $bottom.scrollLeft;
      };
    }

    ref.current = node;
  }, []);

  return [setRef];
};

const TopScrollbar = (props) => {
  const { children } = props;

  const [scrollRef] = useHookWithRefCallback();

  return (
    <div ref={scrollRef}>
      <Wrapper>
        <div />
      </Wrapper>
      {children}
    </div>
  );
};

export default TopScrollbar;
